import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { FarmService } from 'src/app/services/farm-service.service';
import Swal from 'sweetalert2';
import { SchedualDetailService } from '../schedual-detail.service';

@Component({
  selector: "smart-schedual-detail-sync-config",
  templateUrl: "./schedual-detail-sync-config.component.html",
  styleUrls: [
    "./schedual-detail-sync-config.component.scss",
    "../../platform-color/platform-color.css",
  ],
})
export class SchedualDetailSyncConfigComponent implements OnInit {
  @ViewChild("closeModal") private closeModal: ElementRef;
  @Output() done = new EventEmitter<any>();
  @Input() things = [];
  @Input() conditions = [];
  @Input() onlineConfigs = [];
  @Input() account_id: string;
  public submitted: boolean = false;
  public selected: boolean = false;
  public configs = [];
  public thingId: string;
  public selectThingId: string = "";
  public plotId: string;
  public sensorId: string;
  public message: string = "กรุณาเลือกอุปกรณ์ เพื่อแสดงข้อมูล";

  constructor(
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private farmService: FarmService,
    private schedualDetailService: SchedualDetailService
  ) {
    this.thingId = this.route.snapshot.queryParams["thingId"];
    this.plotId = this.route.snapshot.queryParams["plotId"];
    this.sensorId = this.route.snapshot.queryParams["sensorId"];
  }

  ngOnInit(): void {
  }

  getClientConfig(id?: string) {

    this.spinner.show();
    this.farmService.getClientConfig(id).subscribe(async (res) => {
      if (res.code == 200) {
        let config = res.data.ThingConfigInfo.ClientConfig;

        this.configs = await this.schedualDetailService.mapConfigs(config);
        this.spinner.hide();
      } else {
        this.message = "ไม่พบข้อมูล สามารถกำหนดเองที่เมนู เพิ่มข้อมูล";
        this.configs = [];
        this.spinner.hide();
      }
    });
  }

  selectThing(id: string) {
    if (id) {
      this.getClientConfig(id);
    } else {
      this.message = "กรุณาเลือกอุปกรณ์ เพื่อแสดงข้อมูล";
    }
  }

  saveConfig() {
    this.submitted = true;
    if (!this.selectThingId || this.configs.length == 0) {
      return;
    }

    let thing = this.things.find(
      (thing) => thing.thing_id == this.selectThingId
    );

      
    let conditions = this.schedualDetailService.getCondition(this.conditions,  thing._id);

    let operationSet = [];
    operationSet["1"] = ">";
    operationSet["2"] = "<";
    operationSet["3"] = "=";
    operationSet["4"] = "<>";
    operationSet["5"] = "BETWEEN";

    let configs = this.configs
      .map((config) => {
        config.conditions = config.conditions.map(con=>{

          let condition = conditions.find((condition) =>
            operationSet[con.condition] == condition.condition[0].operation &&
                condition.condition[0].sensor_id == config.group
          );
          if(condition){
            let operation = operationSet[con.condition];
            let custom = condition.condition.find(item=> 
                item.operation == operation);
            con.time = custom? parseInt(custom.sch_time): con.time;
            con.time_unit = custom? custom.sch_unit_time: con.time_unit
          }
          return {
            ...con,
            selected: condition? true: false, 
          };
        }).filter((con) => con.selected);
        return {
          ...config,
        };
        
    }).filter((config) => config.conditions.length > 0);

    if(configs.length > 0){
      let findConfig = this.schedualDetailService.getOnlineConfig(this.onlineConfigs, thing.thing_id);

      if (findConfig) {
        let filter = {
          online_config_id: findConfig.OnlineConfigId,
          account_id: this.account_id
        }
        this.farmService.getOnlineConfig(filter).subscribe(res=>{
          if(res.code == 200){
            let config = this.setConfigData(thing, configs, findConfig);

            this.farmService
              .updateOnlineConfig(config, findConfig.OnlineConfigId, this.account_id)
              .subscribe((res) => {
                if (res.code == 200) {
                  this.updateCondition(thing, configs, findConfig.OnlineConfigId);
                } else {
                  this.error();
                }
              });
          }else{
             //IF NOTFOUND
             let config = this.setConfigData(thing, configs);
   
             this.farmService.createOnlineConfig(config).subscribe((res) => {
               if (res.code == 200) {
                 this.updateCondition(
                   thing,
                   configs,
                   res.data.OnlineConfigInfo.OnlineConfigId
                 );
               } else {
                 this.error();
               }
             });
          }
        })
      } else {
        let config = this.setConfigData(thing, configs);

        this.farmService.createOnlineConfig(config).subscribe((res) => {
          if (res.code == 200) {
            this.updateCondition(
              thing,
              configs,
              res.data.OnlineConfigInfo.OnlineConfigId
            );
          } else {
            this.error();
          }
        });
      }
    }else{
      this.closeModal.nativeElement.click();
      Swal.fire({
        icon: "error",
        title: "ไม่พบข้อมูล Config สำหรับการอัพเดท",
        showConfirmButton: false,
        timer: 1500,
      }).then((res) => {
        this.done.emit(true);
      });
    }
  }

  updateCondition(thing, configs, online_config_id) {
    let operationSet = [];
    operationSet["1"] = ">";
    operationSet["2"] = "<";
    operationSet["3"] = "=";
    operationSet["4"] = "<>";
    operationSet["5"] = "BETWEEN";

    configs.map((config) => {
      config.conditions.map((con) => {
        let operation = operationSet[con.condition];
        let condition = [
          {
            thing_id: thing.thing_id,
            thing_name: thing.thing_name,
            sensor_id: config.group,
            sensor_name: config.group,
            operation: operation,
            Value1: con.target_start,
            Value2: con.target_end == "" ? null : con.target_end,
            sch_time: con.time,
            sch_unit_time: con.time_unit,
            sensor_action: con.switch_main == true ? "ON" : "OFF",
          },
        ];

        let jsonData = JSON.stringify(condition);

        let data = [
          {
            sch_name: "",
            sch_type: null,
            sch_date: "",
            sch_time: null,
            sch_unit_time: null,
            sch_start_time: "00.00.00",
            sch_stop_time: "00.00.00",
            thing_id: this.thingId,
            sensor_id: this.sensorId,
            condition: jsonData,
            operation: null,
            sensor_action: con.switch_main ? "ON" : "OFF",
            sch_flag: "CON",
            plot_id: this.plotId,
            sch_status: con.sch_status,
            online_config_id: online_config_id,
          },
        ];
        let findCondition = this.conditions.find((con) =>
          con.condition.find(
            (item) =>
              item.thing_id == thing.thing_id &&
              item.sensor_id == config.group &&
              item.sensor_name == config.group &&
              item.operation == operation
          )
        );

        if (findCondition) {
          data[0]["sch_id"] = findCondition.data.sch_id;
          data[0]["_id"] = findCondition.data._id;
          this.farmService
            .getUpdateSchedulebyId(data)
            .subscribe(async (success) => {
              if (success.code == 200) {
                this.success();
              } else {
                this.error();
              }
            });
        }
      });
    });
  }

  back() {
    this.submitted = false;
    this.selected = false;
    this.selectThingId = "";
    this.configs = [];
  }

  success() {
    this.closeModal.nativeElement.click();
    Swal.fire({
      icon: "success",
      title: "ดำเนินการเสร็จสิ้น",
      showConfirmButton: false,
      timer: 1500,
    }).then((res) => {
      this.done.emit(true);
    });
  }

  error() {
    this.closeModal.nativeElement.click();
    Swal.fire({
      icon: "error",
      title: "เกิดข้อผิดพลาดในการสร้าง กรุณาลองใหม่อีกครั้ง",
      showConfirmButton: false,
      timer: 1500,
    }).then((res) => {
      this.done.emit(true);
    });
  }

  setConfigData(thing, configs, findConfig = null) {
    let operationSet = [];
    operationSet["1"] = ">";
    operationSet["2"] = "<";
    operationSet["3"] = "=";
    operationSet["4"] = "<>";
    operationSet["5"] = "BETWEEN";
    let CustomDetails = {};
    if (findConfig) {
      CustomDetails = {
        ...findConfig.CustomDetails,
      };
    }
    configs.map((config) => {
      config.conditions.map((condition) => {
        let operation = this.schedualDetailService.convertOperation(
          config,
          condition
        );

        if (findConfig) {
          let findCondition = this.conditions.find((con) =>
            con.condition.find(
              (item) =>
                item.thing_id == thing.thing_id &&
                item.sensor_id == config.group &&
                item.sensor_name == config.group &&
                item.operation == operationSet[condition.condition]
            )
          );
          if (findCondition) {
            let beforeCondition = findCondition.condition[0];
            let beforeOperation = this.schedualDetailService.convertOperation(
              config,
              beforeCondition
            );

            if (
              CustomDetails[beforeCondition.sensor_name] &&
              (CustomDetails[beforeOperation.keyStart] ||
                CustomDetails[beforeOperation.keyEnd])
            ) {
              for (var key in CustomDetails)
                if (key.startsWith(beforeCondition.sensor_name)) {
                  delete CustomDetails[beforeOperation.keyStart];
                  delete CustomDetails[beforeOperation.keyEnd];
                }
            }
          }
        }
        CustomDetails = {
          ...CustomDetails,
          [config.group]: condition.sch_status == "ATV"? "1":"0",
        };
        CustomDetails[operation.keyStart] = condition.target_start;
        if (operation.keyEnd) {
          CustomDetails[operation.keyEnd] = condition.target_end;
        }
      });
    });

    let result = {
      OnlineConfigName: findConfig
        ? findConfig.OnlineConfigName
        : thing.thing_name,
      Things: [thing.thing_id],
      CustomDetails: CustomDetails,
    };
    if (findConfig == null) {
      result["AccountId"] = this.account_id
    }
    return result;
  }
}
